import {createNamespacedHelpers} from 'vuex'
import DefaultTmpl from '@/templates/DefaultTmpl'

export default {
    mount(base_name) {
        const {mapActions, mapGetters, mapMutations} = createNamespacedHelpers(base_name);

        let observerPagination = null;

        return {
            components: {
              DefaultTmpl
            },
            data() {
                return {
                    search_params: {},
                    searching: false,
                    filterMode: false
                }
            },
            methods: {
                ...mapActions(['filter', 'destroy', 'resetSearch', 'loadMore']),
                ...mapMutations(['setSearch']),
                createSearchParams() {
                    return {}
                },
                beforeReset() {},
                reset() {
                    this.beforeReset();
                    this.search_params = this.createSearchParams();
                    this.$router.push({name: this.$router.currentRoute.name});
                    if (this.$appUtils.isMobile()) this.filterMode = false;
                },
                beforeSubmit() {
                },
                submit() {
                    this.beforeSubmit();

                    delete this.search_params.page;
                    this.$router.push({path: this.$router.currentRoute.path, query: {...this.search_params}});

                    if (this.$appUtils.isMobile()) this.filterMode = false;
                },
                onFilterSuccess(data){},
                edit(id) {
                    this.$router.push({path: `/${base_name}/${id}/edit`})
                },
                confirmDestroy(idItem, e) {
                    if (e) {
                        e.preventDefault();
                        e.cancelBubble = true;
                    }

                    this.$store.commit('addModal', {title: this.$t('common.destroyItemTitle'), size: 'small', body: this.$t('common.destroyItemMessage'), buttons: [
                            {type: 'ok', class: 'btn btn-danger btn-sm', method: id => {
                                    this.$store.commit('destroyModal', id);
                                    const self = this;
                                    this.destroy(idItem)
                                        .then(() => {
                                            self.$snotify.success(this.$t('common.destroyItemSuccess'), this.$appStorage.getUser().name);
                                            self.filter(`/v1${this.$router.currentRoute.fullPath}`)
                                        })
                                        .catch(() => {
                                            self.$snotify.error(this.$t('common.destroyItemError'), this.$appStorage.getUser().name);
                                        })
                                }},
                            {type: 'close', label: 'Não', focus: true, method: id => this.$store.commit('destroyModal', id)}
                        ]})
                },
                getIntersectItemListener() {
                    return null;
                }
            },
            computed: {
                search: {
                    ...mapGetters({get: 'search'})
                },
                isLoadingMore() {
                    return !this.searching && this.search.entries.length > 0 && this.search.entries.length < this.search.total_entries;
                }
            },
            mounted() {
                const itemIntersect = this.getIntersectItemListener();

                if (this.$appUtils.isMobile() && itemIntersect) {
                    observerPagination = new IntersectionObserver(entries => {
                        entries.forEach(entry => {

                            if (this.isLoadingMore && entry.isIntersecting) {
                                this.searching = true;
                                let page = this.search.current_page + 1;
                                const newRoute = new URLSearchParams({...this.$router.currentRoute.query, page: page});

                                this.loadMore(`/v1${this.$router.currentRoute.path}?${newRoute.toString()}`)
                                    .then(data => {
                                        const newData = this.search.entries.concat(data.entries);
                                        delete data.entries;
                                        this.onFilterSuccess(data);
                                        this.setSearch({...data, entries: newData});
                                    })
                                    .catch(err => {
                                        this.$appUtils.vibrate();
                                        this.$snotify.error(this.$t('common.generalHttpError'), this.$appStorage.getUser().name);

                                        console.error('Load more mobile pagination search', err);
                                    })
                                    .finally(() => this.searching = false);
                            }
                        })
                    }, {
                        root: null,
                        rootMargin: '200px'
                    });

                    observerPagination.observe(itemIntersect);
                }
            },
            beforeRouteEnter (to, from, next) {
                next(vm => {
                    vm.search_params = {...vm.createSearchParams(), ...(to.query || {})};

                    const params = new URLSearchParams(vm.search_params);

                    vm.searching = true;
                    vm.filter(`/v1${to.path}?${params.toString()}`)
                        .then(vm.onFilterSuccess)
                        .finally(() => vm.searching = false);
                });
            },
            beforeRouteUpdate(to, from, next) {
                this.search_params = {...this.createSearchParams(), ...(to.query || {})};
                const params = new URLSearchParams(this.search_params);

                this.searching = true;
                this.filter(`/v1${to.path}?${params.toString()}`)
                    .then(this.onFilterSuccess)
                    .finally(() => this.searching = false)
                ;
                next();
            },
            destroyed() {
                if (observerPagination) {
                    observerPagination.disconnect();
                    observerPagination = null;
                }
            }
        }
    }
};
